import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['Passi ore a pensare a nuovi esercizi per non annoiare i ragazzi.', 'Finisci le idee e ripeti sempre gli stessi cesti e schemi di gioco.', 'Non sai come gestire gruppi con livelli misti nello stesso campo.', 'La pioggia ti costringe ad annullare le lezioni e perdere fatturato.', 'Arrivi al club senza un piano d’azione e finisci per improvvisare ogni ora.'];
export function ProblemSection() {
  return <section className="bg-[#0a0f0c] px-5 py-16" data-id="element-183" data-mp="35gkj141y4kbe">
      <div className="mx-auto max-w-4xl text-center" data-id="element-184" data-mp="35fr8drzv9anz">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-185" data-mp="3jftqnfc3663r">
          La realtà dell'insegnamento sul campo
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-186" data-mp="3ehic4rauj7f7">
          Insegni Tennis? Questi problemi ti suonano familiari?
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-187" data-mp="1k49bzq46wy9m">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-[#141b16] p-4" data-id="element-188" data-mp="jeohcbefbqo8">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-lime-300" data-id="element-189" data-mp="sdtfvhpzjk0e" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-190" data-mp="sbp1u6ydh4me">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-emerald-300 sm:text-4xl" data-id="element-191" data-mp="122jq1gv6ieah">
          Per quanto ancora vuoi continuare a improvvisare il tuo Tennis?
        </p>
      </div>
    </section>;
}